import { render, staticRenderFns } from "./league-manage.vue?vue&type=template&id=24f9d076&"
import script from "./league-manage.vue?vue&type=script&lang=js&"
export * from "./league-manage.vue?vue&type=script&lang=js&"
import style0 from "./league-manage.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "league-manage.vue"
export default component.exports